module.exports = __webpack_public_path__ + "static/media/elixir-logo.30e3efde.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/elixir-logo.png
// module id = 830
// module chunks = 0